export default {
    USERS: '@_get_users',
    SINGLEUSER: '@_get_single_user',
    DELETEUSER: '@delete_user',
};
